setInterval(() =>{
	console.log("about to throw");
	throw new Error('error');
}, 1000);
